import { Dialog, DialogBackdrop, DialogPanel }  from '@headlessui/react';
import Select                                   from 'react-select';
import DateInput                                from '../DateInput';

export default function PxoCreateForm ({
    isOpen, 
    onClose, 
    onSubmit, 
    onChangeSelect, 
    selectedDateType, 
    selectValues, 
    onChangeDate,
    isSubmitting,
    errorMessage
}) {
    
    return(

        <Dialog open={isOpen} onClose={onClose} className="relative z-[100] ">

            <DialogBackdrop 
                transition 
                className="fixed inset-0 bg-bg-backdrop transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />
            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                
                <div className=" flex min-h-full items-end justify-center p-1 text-center sm:items-center sm:p-0">
                    
                    <DialogPanel 
                        transition 
                        className="w-[505px] min-h-[505px]relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8  data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                    >   
                        
                        <div className="app-container">
                            
                            {/* #region header */}
                            
                            <header className="bg-azul-profundo-m flex justify-between items-center pl-4 pr-1 py-3">
                            
                                <h2 className="text-white text-[1rem] leading-7 font-semibold">Criar Novo PxO</h2>
                                <button onClick={onClose} className="text-[1.2rem] text-white hover:text-gray-200 pr-2">×</button>
                            
                            </header>

                            {/* #endregion */}

                            <div className="px-4 pb-4 pt-2 sm:pb-4 flex flex-col gap-[10px] ">
      
                                <div className="flex flex-col w-full">
                                        
                                    <span className="text-sm font-semibold">Tipo de Horizonte:</span>
                                    
                                   <Select
                                        defaultValue={selectValues[0]}
                                        options={selectValues}
                                        className="basic-select"
                                        classNamePrefix="select"
                                        isSearchable={false}
                                        onChange={(newValue) => onChangeSelect(newValue)}
                                        menuPortalTarget={document.body}
                                        menuPosition="fixed"
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 })
                                        }}
                                    />

                                </div>

                            </div>

                            <div className="px-4 pt-1 pb-4 flex flex-col gap-[10px]">
      
                                <div className="flex flex-col w-full">
                                        
                                    <span className="text-sm font-semibold">Data:</span>
                                    
                                    <DateInput 
                                        
                                        selectedDateType={selectedDateType } 
                                        className="w-full" 
                                        onChange={
                                            (newValue) => {

                                                onChangeDate(newValue)
                                            }
                                        }

                                    />

                                    {errorMessage && (
                                        <span className="text-sm text-red-600 mt-1">
                                            {errorMessage}
                                        </span>
                                    )}
                                    
                                </div>

                            </div>

                            {/* #region footer */}            
                            <footer className="w-full bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                
                                <button 
                                    type="submit" 
                                    onClick={() => onSubmit()} 
                                    disabled={isSubmitting}
                                    className="btn btn-azul-prof sm:ml-3 w-[100%] text-[1.125rem] disabled:opacity-60 disabled:cursor-not-allowed"
                                >
                                    {isSubmitting ? 'Criando PxO...' : 'Salvar'}
                                </button>

                              
                                
                            </footer>
                            {/* #endregion */}            
                        </div>
                        
                    </DialogPanel>
                </div>
            </div>
        </Dialog>

    )

}